<template>
  <div v-if="lessonList.length > 0"
       class="course-lesson-list"
  >
    <item v-for="item in lessonList"
          :key="item.lesson.id"
          :course-id="courseId"
          :member="member"
          :lesson="item.lesson"
          :medal="item.medal"
          :sell-status="sellStatus"
          :work="item.work"
          :practice="item.practice"
          :challenge="item.challenge"
    />
<!--    <div class="course-medal"-->
<!--         v-if="medal"-->
<!--    >-->
<!--      <ym-img class="course-medal-img"-->
<!--              :src="medal.src"-->
<!--              :alt="medal.title"-->
<!--              lazy-->
<!--      />-->
<!--      <div class="course-medal-desc">{{ medal.desc }}</div>-->
<!--    </div>-->
    <div class="course-sort"
         @click="changeSort"
    >
      <ym-icon class="icon"
               name="mr-sort"
      />
      {{ sortText }}
    </div>
  </div>
  <div v-else
       class="empty"
  >
    直播课时尚未更新，请留意简介
  </div>
</template>

<script>
  import Item from '@/pages/Course/components/CourseDetailLessonItem';
  import validator from '@/utils/validator';

  export default {
    name: 'CourseDetailLessonList',
    components: {
      Item,
    },
    props: {
      courseId: {
        type: Number,
        required: true,
      },
      medal: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      list: {
        type: Array,
        required: true,
      },
      member: {
        type: Boolean,
        required: true,
      },
      sellStatus: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        lessonList: [],
        sortText: '正序',
      };
    },
    methods: {
      changeSort() {
        this.lessonList.reverse();
        this.sortText = this.sortText === '正序' ? '倒序' : '正序';
      },
    },
    created() {
      this.lessonList = this.list;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .course-lesson-list {
    position: relative;
    padding-top: 60px;
    padding-bottom: @size-base;
    min-height: @product-tab-min-height;
    overflow: auto;
    background: #f5f6f7;
  }

  @course-medal-padding: (@size-base * 1.5);
  @course-medal-size: 160px;
  .course-medal {
    display: flex;
    align-items: center;
    padding: 0 @course-medal-padding (@size-medium * 2);
  }

  .course-medal-img {
    display: block;
    width: @course-medal-size;
    position: relative;
    z-index: @z-index-medium;
  }

  .course-medal-desc {
    flex: 1;
    display: flex;
    align-items: center;
    height: 114px;
    line-height: 1.6;
    padding: 0 @size-base;
    background: @color-primary-lighter;
    font-size: @font-size-small;
    font-weight: @font-weight-primary;
    border-top-right-radius: @border-radius-normal;
    border-bottom-right-radius: @border-radius-normal;
    position: relative;
    &::before {
      content: '';
      display: block;
      background: @color-primary-lighter;
      position: absolute;
      top: 0;
      bottom: 0;
      width: (@course-medal-size / 2);
      right: 100%;
    }
  }

  .course-sort {
    position: absolute;
    top: @size-base;
    right: @size-base;
    z-index: 2;
    width: 104px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: @color-white;
    color: @color-text-lighter;
    font-size: @font-size-small;
    border-radius: 13px;
    cursor: pointer;
  }
</style>
